import * as React from 'react';

function SvgTotalContestWin(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} {...props}>
      <defs>
        <style>
          {
            '.total_contest_win_svg__prefix__cls-4{fill:#fee903}.total_contest_win_svg__prefix__cls-5{fill:#fed402}.total_contest_win_svg__prefix__cls-6{fill:#f4d902}.total_contest_win_svg__prefix__cls-7{fill:#fac600}.total_contest_win_svg__prefix__cls-14{fill:#6bd9e7}'
          }
        </style>
      </defs>
      <g id="total_contest_win_svg__prefix__total_contest_win" transform="translate(-24 -515)">
        <path
          id="total_contest_win_svg__prefix__bound"
          fill="none"
          d="M0 0h35v35H0z"
          transform="translate(24 515)"
        />
        <g
          id="total_contest_win_svg__prefix__trophy_15_"
          data-name="trophy (15)"
          transform="translate(-4.336 518)"
        >
          <circle
            id="total_contest_win_svg__prefix__Ellipse_459"
            cx={11.166}
            cy={11.166}
            r={11.166}
            fill="#ff4893"
            data-name="Ellipse 459"
            transform="translate(34.675 2.851)"
          />
          <circle
            id="total_contest_win_svg__prefix__Ellipse_460"
            cx={7.146}
            cy={7.146}
            r={7.146}
            fill="#ebebeb"
            data-name="Ellipse 460"
            transform="translate(38.695 6.871)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5222"
            d="M333.839 299.064l-2.969-1.664-.774-.642-2.941 2.884.825.636 1.667 2.976.42.42 4.259-4.259z"
            className="total_contest_win_svg__prefix__cls-4"
            data-name="Path 5222"
            transform="translate(-277.613 -280.391)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5223"
            d="M73.682 39.153a2.827 2.827 0 01-.825-1.846l-.057-1.044a7.722 7.722 0 00-.046-.528 7.925 7.925 0 00-2.263-4.644l-.735-.735-1.616-1.464-7.74 7.627 1.6 1.595.735.735a7.927 7.927 0 004.644 2.263q.262.032.528.047l1.045.057a2.836 2.836 0 011.846.825l.1.1a.938.938 0 001.326 0l2.223-2.223z"
            className="total_contest_win_svg__prefix__cls-4"
            data-name="Path 5223"
            transform="translate(-25.575 -27.298)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5224"
            d="M331.825 321.466l-.42-.42-1.667-2.976-.806-.621-1.777 1.743.825.636 1.667 2.976.42.42 4.259-4.259z"
            className="total_contest_win_svg__prefix__cls-5"
            data-name="Path 5224"
            transform="translate(-277.613 -299.94)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5225"
            d="M74.251 136.284a.938.938 0 01-1.326 0l-.1-.1a2.836 2.836 0 00-1.846-.825l-1.045-.057q-.266-.015-.528-.047a7.927 7.927 0 01-4.644-2.263l-.735-.735-1.58-1.581-2.047 2.011 1.594 1.6.735.735a7.927 7.927 0 004.644 2.263q.262.032.528.047l1.045.057a2.836 2.836 0 011.846.825l.1.1a.938.938 0 001.326 0l2.223-2.223z"
            className="total_contest_win_svg__prefix__cls-5"
            data-name="Path 5225"
            transform="translate(-25.574 -123.466)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5226"
            d="M74.61 39.107l-.658.409a1.954 1.954 0 00-.629.629l-.411.662a1.609 1.609 0 111.7-1.7z"
            className="total_contest_win_svg__prefix__cls-4"
            data-name="Path 5226"
            transform="translate(-35.959 -35.518)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5227"
            d="M51 7.981a.484.484 0 010 .684l-.35.35-2.457 2.457-2.843 2.843-2.457 2.457-.35.35a.484.484 0 01-.684 0l-.392-.392a.342.342 0 010-.483l1.733-1.74 1.331-2.142.411-.662a1.955 1.955 0 01.629-.629l.658-.409 2.151-1.334 1.741-1.742a.342.342 0 01.484 0z"
            className="total_contest_win_svg__prefix__cls-6"
            data-name="Path 5227"
            transform="translate(-7.583 -7.076)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5228"
            d="M50.731 11.576l-1.011 1.011-2.843 2.843-2.457 2.457-.35.35a.484.484 0 01-.684 0l-.061-.061-.119.192-1.743 1.742a.342.342 0 000 .483l.392.392a.484.484 0 00.684 0l.35-.35 2.457-2.457 2.843-2.843 2.457-2.457.35-.35a.484.484 0 000-.684z"
            className="total_contest_win_svg__prefix__cls-7"
            data-name="Path 5228"
            transform="translate(-7.584 -10.937)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5229"
            fill="#fed2a4"
            d="M186.742 228.191a.556.556 0 11-.869-.548.775.775 0 11-1.1-1.1 1.143 1.143 0 01-1.324-1.645.775.775 0 00-1.1 0l-2.226 2.226a.938.938 0 01-1.326 0l-.1-.1a2.827 2.827 0 00-.389-.324l-.365 1.062a1.5 1.5 0 00.3 1.435l.424.485-4.064 4.065 2.932 2.894 4.376-4.376a1.921 1.921 0 002.213-.362l1.313-1.313 1.3-1.3a.776.776 0 000-1.1z"
            data-name="Path 5229"
            transform="translate(-133.481 -212.282)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5230"
            fill="#ffbd86"
            d="M175.128 234.258l4.061-4.062-.424-.485a1.5 1.5 0 01-.3-1.435l.365-1.062a2.827 2.827 0 01.389.324l.1.1a.938.938 0 001.326 0l2.226-2.226a.775.775 0 01.775-.193.775.775 0 00-1.29-.322l-2.226 2.226a.938.938 0 01-1.326 0l-.1-.1a2.828 2.828 0 00-.389-.324l-.365 1.062a1.5 1.5 0 00.3 1.435l.424.485-4.064 4.065z"
            data-name="Path 5230"
            transform="translate(-133.481 -212.283)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5231"
            d="M372.451 334.734a.707.707 0 010 1l-4.3 4.3a.707.707 0 11-1-1l.09-.091 4.191-4.191.014-.014a.707.707 0 011.005-.004z"
            className="total_contest_win_svg__prefix__cls-6"
            data-name="Path 5231"
            transform="translate(-315.21 -316.075)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5232"
            d="M368.938 383.311a.706.706 0 010-1l.09-.091-1.782 1.78-.09.091a.707.707 0 101 1l1.782-1.782a.707.707 0 01-1 .002z"
            className="total_contest_win_svg__prefix__cls-7"
            data-name="Path 5232"
            transform="translate(-315.211 -361.138)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5233"
            fill="#00f2a6"
            d="M200.875 329.276a.425.425 0 010 .6l-1.026 1.025a.424.424 0 01-.6 0l-.226-.226-2.913-2.913-.226-.226a.425.425 0 010-.6l1.025-1.025a.425.425 0 01.6 0l.226.226 2.913 2.913z"
            data-name="Path 5233"
            transform="translate(-153.464 -307.817)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5234"
            fill="#05e39c"
            d="M197.79 328.194a.745.745 0 010-1.053l.476-.476-.528-.528-.226-.226a.425.425 0 00-.6 0l-1.025 1.025a.425.425 0 000 .6l.226.226 2.913 2.913.226.226a.425.425 0 00.6 0l.324-.323z"
            data-name="Path 5234"
            transform="translate(-153.465 -307.816)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5235"
            fill="#08a9f1"
            d="M57.117 381.932a.6.6 0 010 .854l-2.539 2.539a.759.759 0 01-.537.222h-7.059a.231.231 0 01-.163-.394l6.333-6.333a.6.6 0 01.854 0l.1.1 2.913 2.913z"
            data-name="Path 5235"
            transform="translate(-12.674 -357.759)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5236"
            fill="#0290cf"
            d="M54.584 380.254a.6.6 0 01.854 0L54.1 378.92l-.1-.1a.6.6 0 00-.854 0l-6.333 6.333a.231.231 0 00.163.394h2.307z"
            data-name="Path 5236"
            transform="translate(-12.674 -357.759)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5237"
            d="M378.265 85.345a3.1 3.1 0 01-.805.814.271.271 0 000 .45 2.954 2.954 0 01.808.787.269.269 0 00.445 0 2.864 2.864 0 01.813-.805.27.27 0 000-.446 3.261 3.261 0 01-.819-.809.27.27 0 00-.442.009z"
            className="total_contest_win_svg__prefix__cls-14"
            data-name="Path 5237"
            transform="translate(-325.029 -80.525)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5238"
            d="M135.918 155.432a3.122 3.122 0 01-1.079 1.085.138.138 0 000 .236 2.967 2.967 0 011.08 1.06.138.138 0 00.239 0 2.885 2.885 0 011.078-1.069.138.138 0 00.005-.236 3.285 3.285 0 01-1.087-1.077.138.138 0 00-.236.001z"
            className="total_contest_win_svg__prefix__cls-14"
            data-name="Path 5238"
            transform="translate(-95.841 -146.797)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5239"
            d="M57.534 18.366a1.122 1.122 0 00-1.339-.185l-2.362-1.324a1.186 1.186 0 00-1.033-1.584 1.183 1.183 0 00-1.1-1.1 1.184 1.184 0 00-1.1-1.1 1.187 1.187 0 00-1.682-.991l-.526-.526a2.412 2.412 0 01-.7-1.576l-.057-1.045a8.725 8.725 0 00-.041-.485l.923-4.334a2.435 2.435 0 00-4.462-1.772l-.411-.411.058-.058a.9.9 0 000-1.269l-.388-.385a.756.756 0 00-1.068 0l-1.708 1.708-1.615 1A2.023 2.023 0 1036.3 5.562l-1 1.611-1.714 1.707a.756.756 0 000 1.068l.392.392a.9.9 0 001.27 0l.058-.058.411.411a2.436 2.436 0 001.255 4.517 2.475 2.475 0 00.516-.055l4.335-.924c.161.018.322.033.484.041l1.045.057a2.412 2.412 0 01.962.258l-.241.766a1.921 1.921 0 00.384 1.831l.17.194-.359.359a.84.84 0 00-1.115.063l-1.026 1.026a.838.838 0 00-.063 1.115l-.664.659a1.017 1.017 0 00-1.219.167L33.457 27.5a.414.414 0 10.585.585l6.727-6.727a.19.19 0 01.269 0l3.111 3.111a.19.19 0 010 .269L41.388 27.5a.414.414 0 00.585.585l2.762-2.762A1.016 1.016 0 0044.9 24.1l.661-.661a.839.839 0 001.115-.063l1.024-1.024a.838.838 0 00.063-1.115l.768-.768a2.343 2.343 0 001.654-.054l1.341 2.394a1.121 1.121 0 001.707 1.439l4.3-4.3a1.122 1.122 0 000-1.585zM45.56 2.116a1.607 1.607 0 012.152 1.834l-.557 2.613A8.332 8.332 0 0045.208 3.5l-.537-.537a1.594 1.594 0 01.889-.847zM36.2 4.528a1.2 1.2 0 112-1.147l-.426.265a2.385 2.385 0 00-.762.762l-.268.43a1.193 1.193 0 01-.544-.31zm-1.636 5.227l-.341-.341 1.691-1.691a.411.411 0 00.059-.074l1.742-2.8a1.554 1.554 0 01.5-.5l.656-.408 2.145-1.333a.418.418 0 00.074-.059L42.78.857l.341.341a.07.07 0 010 .1l-8.458 8.457a.07.07 0 01-.099 0zm7.789 3.691a7.522 7.522 0 01-3.7-1.211.414.414 0 10-.452.693 8.343 8.343 0 001.728.86l-2.615.557a1.607 1.607 0 01-.987-3.041l.524.524a.414.414 0 00.585-.585l-.727-.727-.82-.82 7.172-7.173.82.82.739.739a7.5 7.5 0 012.143 4.388q.031.253.045.51l.057 1.045a3.239 3.239 0 00.945 2.116l.474.474-1.931 1.931a.525.525 0 01-.741 0l-.1-.1A3.239 3.239 0 0043.4 13.5zm-.337 7.714l.63-.63 2.328 2.328-.63.63zm5.1.606l-1.026 1.026a.011.011 0 01-.016 0l-3.365-3.365a.013.013 0 010-.016l1.026-1.026a.011.011 0 01.008 0 .011.011 0 01.008 0l3.365 3.365a.013.013 0 01.002.017zm4.376-2.993a.414.414 0 00-.585 0l-.552.552a1.509 1.509 0 01-2.132 0 .414.414 0 00-.585.585c.048.048.1.092.148.135l-.6.6-2.329-2.325.629-.629a.414.414 0 00.019-.565l-.424-.485a1.089 1.089 0 01-.218-1.038l.152-.483.017.017a1.353 1.353 0 001.911 0l2.225-2.225a.362.362 0 11.511.512l-.309.309-.388.388a.414.414 0 00.585.585l.388-.388.309-.309a.362.362 0 11.511.511l-.146.146-.551.551a.414.414 0 10.585.585l.551-.551.145-.146a.362.362 0 01.512.511l-.146.146-.551.551a.414.414 0 00.585.585l.551-.551.146-.146a.361.361 0 01.543.474.411.411 0 00-.093.1l-.829.829a.414.414 0 00.585.585l.665-.665 2.219 1.243-3.419 3.419-1.244-2.221.057-.054.552-.552a.414.414 0 000-.585zm5.455.593l-4.3 4.3a.294.294 0 11-.415-.415l.09-.09 4.191-4.191.014-.014a.294.294 0 11.415.415z"
            data-name="Path 5239"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5240"
            d="M310.242 131.557a6.742 6.742 0 013.787 6.068.414.414 0 10.827 0 7.57 7.57 0 00-4.251-6.811.414.414 0 10-.364.743z"
            data-name="Path 5240"
            transform="translate(-261.413 -123.559)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5241"
            d="M128.647 281.066a.414.414 0 00.294-.7 6.738 6.738 0 01-1.775-3.221.414.414 0 10-.806.186 7.565 7.565 0 001.992 3.617.412.412 0 00.295.118z"
            data-name="Path 5241"
            transform="translate(-87.883 -261.551)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5242"
            d="M257.717 434.132a10.742 10.742 0 01-4.347.908.414.414 0 000 .827 11.566 11.566 0 004.679-.978.414.414 0 00-.333-.758z"
            data-name="Path 5242"
            transform="translate(-207.507 -410.153)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5243"
            d="M429.293 146.07a10.86 10.86 0 011.252 7.517.414.414 0 10.812.159 11.689 11.689 0 00-1.349-8.091.414.414 0 00-.716.415z"
            data-name="Path 5243"
            transform="translate(-374.064 -137.427)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5244"
            d="M325.015 57.673a10.793 10.793 0 011.418.655.414.414 0 10.4-.724 11.636 11.636 0 00-1.527-.706.414.414 0 10-.292.774z"
            data-name="Path 5244"
            transform="translate(-275.338 -53.736)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5245"
            d="M55.352 289.653a.414.414 0 00.316-.68 10.8 10.8 0 01-2.378-5.058.414.414 0 10-.814.145 11.628 11.628 0 002.56 5.446.413.413 0 00.316.147z"
            data-name="Path 5245"
            transform="translate(-18.077 -267.933)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5246"
            d="M365.317 75.292a2.559 2.559 0 011.226 1.214.414.414 0 00.373.245.414.414 0 00.373-.236 2.5 2.5 0 011.218-1.217.414.414 0 00.022-.734 2.909 2.909 0 01-1.244-1.236.414.414 0 00-.366-.228.414.414 0 00-.366.221 2.727 2.727 0 01-1.229 1.233.414.414 0 00-.009.737zm1.6-1.009a3.635 3.635 0 00.639.629 3.269 3.269 0 00-.638.632 3.38 3.38 0 00-.636-.618 3.516 3.516 0 00.639-.644z"
            data-name="Path 5246"
            transform="translate(-313.46 -69.068)"
          />
          <path
            id="total_contest_win_svg__prefix__Path_5247"
            d="M128.041 146.709a2.909 2.909 0 01-1.244-1.236.414.414 0 00-.366-.228.414.414 0 00-.366.222 2.726 2.726 0 01-1.228 1.233.414.414 0 00-.009.737 2.559 2.559 0 011.226 1.214.414.414 0 00.373.245.414.414 0 00.373-.236 2.5 2.5 0 011.218-1.217.414.414 0 00.022-.734zm-1.613.979a3.377 3.377 0 00-.636-.618 3.524 3.524 0 00.635-.643 3.635 3.635 0 00.639.629 3.27 3.27 0 00-.637.633z"
            data-name="Path 5247"
            transform="translate(-86.232 -137.234)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgTotalContestWin;
